import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class ButDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"BUT"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "BUT",
            buteur: event.detail?.buteur,
            passeur: event.detail?.passeur,
            butSucced: event.detail?.butSucced ?? true,
          };
    }

    get buteur() {
        return this.detail.buteur;
    }
    set buteur(value) {
        this.detail.buteur = value;
    }

    get passeur() {
        return this.detail.passeur;
    }
    
    set passeur(value) {
        this.detail.passeur = value;
    }

    get butSucced() {
        return this.detail.butSucced;
    }

    set butSucced(value) {
        this.detail.butSucced = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "buteur", "passeur", "butSucced"].includes(key)){
            let commentaire = "But"

            const buteurPlayer = getPlayer(this.buteur, match)
            const passeurPlayer = getPlayer(this.passeur, match)
            const team = getTeam(this.team, match)

            if(this.buteur){
                if(this.buteur === 'csc'){
                    commentaire += ' contre son camp'
                }else if(buteurPlayer){
                    commentaire += ' de '+ buteurPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            if(this.passeur && passeurPlayer){
                commentaire += " sur une passe décisive de "+passeurPlayer.lastname
            }

            commentaire += "! "

            if(!this.butSucced)
                 commentaire += "Malheureusement le but a été refusé."

            this.text = commentaire
        }
    }
}